import { intervalleHebdomadaire } from './cadence';
import { useSollicitation } from './useSollicitation';
import { InvitationAbonnement } from './InvitationAbonnement';
import { useVersionGratuite } from './regime';

/**
 * Exportée : la présentation de la première ouverture d'un dossier la repousse d'un
 * intervalle. Sans cela, un parent pouvait recevoir la carte d'accueil et la fenêtre du
 * rappel dans la même minute — deux fois la même offre, dont l'une par-dessus l'autre.
 */
export const CLE_RAPPEL = 'repere.rappel-abonnement';

/**
 * Le rappel périodique des formules Solo et Duo, une à deux fois par semaine.
 *
 * C'est la même fenêtre que celle qui répond à une écriture refusée — mêmes tarifs, même
 * liste, même phrase sur ce qui reste lisible. Deux fenêtres auraient divergé au premier
 * changement de prix, et un parent qui voit deux argumentaires différents pour une seule
 * offre se demande lequel est le vrai.
 *
 * Elle ne s'affiche qu'à un compte gratuit **avéré**, jamais pendant que la réponse du
 * serveur est en route : mieux vaut sauter une occasion que présenter une offre à
 * quelqu'un qui l'a déjà payée.
 */
export function RappelAbonnement() {
  const gratuit = useVersionGratuite();
  const { due, honorer } = useSollicitation(CLE_RAPPEL, () =>
    intervalleHebdomadaire(Math.random()),
  );

  if (!gratuit || !due) return null;

  return <InvitationAbonnement motif="rappel" onFermer={honorer} />;
}
